import _ from 'lodash';
window._ = _;

window.$ = $;

window.moment = require('moment');
window.moment.locale('hu');

import Popper from 'popper.js';

window.Popper = Popper;

window.swal = require('sweetalert2');

window.escapeStringRegexp = require('escape-string-regexp');
